import { defineEventRegistry } from '@pkg/server/events'
import { hlcString } from '@pkg/sync/common'
import { z } from 'zod'

export const icareRegistry = defineEventRegistry({
  source: 'https://icare.confido-care.de/spec',
  typePrefix: 'de.confido-care.icare',
})

export const SyncDataChangedEventSchema = icareRegistry.defineEvent({
  type: 'sync.changed',
  data: z.object({
    intentTs: hlcString,
  }),
})

export const ClientStatusChangedEventSchema = icareRegistry.defineEvent({
  type: 'client-status.changed',
  data: z.object({
    userId: z.string(),
    nodeId: z.string(),
  }),
})

export const AppEventSchema = z.union([SyncDataChangedEventSchema.schema, ClientStatusChangedEventSchema.schema])

export type AppEvent = z.infer<typeof AppEventSchema>
